module.exports = __webpack_public_path__ + "images/home/orientation/up-next.6b180fd2d4526f7925c9.svg";